
    import './styles.scoped.css';
    export default {
  "flash-refresh": "awsui_flash-refresh_1q84n_zqvy6_93",
  "enter": "awsui_enter_1q84n_zqvy6_93",
  "flash-body": "awsui_flash-body_1q84n_zqvy6_108",
  "flash-message": "awsui_flash-message_1q84n_zqvy6_108",
  "flash-header": "awsui_flash-header_1q84n_zqvy6_108",
  "flash-content": "awsui_flash-content_1q84n_zqvy6_109",
  "action-button-wrapper": "awsui_action-button-wrapper_1q84n_zqvy6_110",
  "dismiss-button-wrapper": "awsui_dismiss-button-wrapper_1q84n_zqvy6_111",
  "flash-icon": "awsui_flash-icon_1q84n_zqvy6_134",
  "entering": "awsui_entering_1q84n_zqvy6_147",
  "entered": "awsui_entered_1q84n_zqvy6_168",
  "exiting": "awsui_exiting_1q84n_zqvy6_273",
  "flashbar": "awsui_flashbar_1q84n_zqvy6_295",
  "flash": "awsui_flash_1q84n_zqvy6_93",
  "flash-text": "awsui_flash-text_1q84n_zqvy6_359",
  "dismiss-button": "awsui_dismiss-button_1q84n_zqvy6_111",
  "breakpoint-default": "awsui_breakpoint-default_1q84n_zqvy6_401",
  "action-button": "awsui_action-button_1q84n_zqvy6_110",
  "flash-type-success": "awsui_flash-type-success_1q84n_zqvy6_414",
  "flash-type-error": "awsui_flash-type-error_1q84n_zqvy6_418",
  "flash-type-warning": "awsui_flash-type-warning_1q84n_zqvy6_422",
  "flash-type-info": "awsui_flash-type-info_1q84n_zqvy6_426"
};
  